import { VStack } from '@chakra-ui/react';
import EntityTrialSection from './accordionSections/EntityTrialSection';
import EntityAdminGeneral from './accordionSections/EntityAdminGeneral';
import EntityDangerZone from './accordionSections/EntityDangerzone';

const CompanyAdmin = ({
    darkMode,
    errors,
    touched,
    isCompany,
    resetToMainTable,
}) => {
    return (
        <VStack spacing={4} align="stretch">
            {isCompany && (
                <EntityTrialSection
                    darkMode={darkMode}
                    errors={errors}
                    touched={touched}
                    resetToMainTable={resetToMainTable}
                />
            )}
            <EntityAdminGeneral
                darkMode={darkMode}
                errors={errors}
                touched={touched}
                resetToMainTable={resetToMainTable}
            />
            <EntityDangerZone
                darkMode={darkMode}
                isCompany={isCompany}
                resetToMainTable={resetToMainTable}
            />
        </VStack>
    );
};

export default CompanyAdmin;
